import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'sm' | 'default' | 'lg';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'default',
  size = 'default',
  children,
  className = '',
  ...props
}) => {
  const baseStyles = 'ha-inline-flex ha-items-center ha-justify-center ha-rounded-lg ha-font-medium ha-transition-all ha-duration-300';
  
  const variants = {
    default: 'ha-bg-primary ha-text-primary-foreground hover:ha-scale-105 ha-glow-primary',
    outline: 'ha-border-2 ha-border-primary ha-text-primary hover:ha-bg-primary\\/10',
    ghost: 'hover:ha-bg-secondary ha-text-foreground',
  };
  
  const sizes = {
    sm: 'ha-px-3 ha-py-2 ha-text-sm',
    default: 'ha-px-4 ha-py-2 ha-text-base',
    lg: 'ha-px-6 ha-py-3 ha-text-lg',
  };
  
  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};
